import { combineEpics } from 'redux-observable';

import { findUserTicketEpic }        from './FindUserTicket/FindUserTicketEpic';
import { findUserTicketsEpic }       from './FindUserTickets/FindUserTicketsEpic';
import { createUserTicketsEpic }     from './CreateUserTickets/CreateUserTicketsEpic';
import { downloadUserTicketPdfEpic } from './DownloadUserTicketPdf/DownloadUserTicketPdfEpic';


export const userTicketEpics = combineEpics(
  findUserTicketEpic,
  findUserTicketsEpic,
  createUserTicketsEpic,
  downloadUserTicketPdfEpic,
);
